import React from "react";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";

import Button from "@/components/button";
import { useModal } from "@/hooks/use-modal";

import { ButtonBar, Module } from "../../layouts";
import { ButtonGroup } from "../../layouts/button-group";

import ModalTitle from "./modal-title";

export default function ReportSubmittedModal() {
  const { closeModal } = useModal();

  return (
    <div className="text-center">
      <ModalTitle>Report Submitted</ModalTitle>
      <Module>
        <p>Thank you for your report.</p>
        <p>
          If the animation is found to be inappropriate, it will be removed from
          the public gallery as soon as possible.
        </p>
      </Module>
      <ButtonBar>
        <ButtonGroup align="right">
          <Button
            icon={faCheckCircle}
            onClick={closeModal}
            type="positive"
            rightAlign
          >
            Ok
          </Button>
        </ButtonGroup>
      </ButtonBar>
    </div>
  );
}
